export var removeUnicode = function (text) {
    // eslint-disable-next-line no-control-regex
    return text.replace(/[^\x00-\x7F\s]/g, '');
};
